import React from 'react'
import styled from 'styled-components'
import { gradients } from '../theme/sharedComponents'

const Badge = styled.span<{ $large?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  background: ${gradients.primary};
  color: #fff;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  gap: ${p => p.$large ? '0.3rem' : '0.18rem'};
  z-index: 2;
  pointer-events: none;
  border-radius: 0 0 0.45rem 0;
  font-size: ${p => p.$large ? '0.75rem' : '0.6rem'};
  padding: ${p => p.$large ? '0.35rem 0.75rem' : '0.2rem 0.5rem'};
  box-shadow: 0 2px 6px color-mix(in srgb, var(--color-primary) 25%, transparent);

  i { font-size: ${p => p.$large ? '0.8rem' : '0.65rem'}; }
`

const SaleCornerBadge: React.FC<{ large?: boolean }> = ({ large }) => (
  <Badge $large={large}>
    <i className="bi bi-lightning-fill" />
    Sale
  </Badge>
)

export default SaleCornerBadge
